import { UNIFIED_SHIPPING_DOCUMENTS } from 'App/featuresFlags';
import useGetTags from '../useGetTags';

function useHasUnifiedShippingDocumentsEnabled(): boolean {
  const tags = useGetTags();
  return tags.includes(UNIFIED_SHIPPING_DOCUMENTS);
}

export default useHasUnifiedShippingDocumentsEnabled;
